export const WHITE_LISTED_PATHS = [
    '/login',
    '/signup',
    '/reset-password',
    '/terms'
];
